import levels from '~/core/constants/levels';
import questions, { knowledgeQuestions } from '~/core/constants/questions';
import { StorageKeys } from '../constants/data';
import ages from '../constants/ages';

class Quiz {

  private static _answers = {
    [StorageKeys.ParentAnswers]: new Map<string, string>(),
    [StorageKeys.AdultAnswers]: new Map<string, string>(),
  };

  private static _age = {
    [StorageKeys.ParentAge]: '',
    [StorageKeys.AdultAge]: '',
  };

  private static loadAnswers( type: 'parent' | 'adult' ) {

    if ( type === 'parent' ) {

      const answers = localStorage.getItem( StorageKeys.ParentAnswers );
      const age = localStorage.getItem( StorageKeys.ParentAge );

      if ( answers ) {

        this._answers[StorageKeys.ParentAnswers] = new Map( JSON.parse( answers ) );

      }

      if ( age ) {

        this._age[StorageKeys.ParentAge] = age;

      }

    }

    if ( type === 'adult' ) {

      const answers = localStorage.getItem( StorageKeys.AdultAnswers );
      const age = localStorage.getItem( StorageKeys.AdultAge );

      if ( answers ) {

        this._answers[StorageKeys.AdultAnswers] = new Map( JSON.parse( answers ) );

      }

      if ( age ) {

        this._age[StorageKeys.AdultAge] = age;

      }

    }

  }

  static clearAnswers( type: 'parent' | 'adult' ) {

    const storageType = type === 'adult' ? StorageKeys.AdultAnswers : StorageKeys.ParentAnswers;

    this._answers[storageType].clear();

    localStorage.removeItem( storageType );

  }

  static saveAnswer( question: string, answer: string, type: 'parent' | 'adult' ) {

    const storageType = type === 'adult' ? StorageKeys.AdultAnswers : StorageKeys.ParentAnswers;

    this._answers[storageType].set( question, answer );

    localStorage.setItem(
      storageType,
      JSON.stringify( Array.from( this._answers[storageType] ) ),
    );

  }

  static getAnswer( question: string, type: 'parent' | 'adult' ) {

    const storageType = type === 'adult' ? StorageKeys.AdultAnswers : StorageKeys.ParentAnswers;

    return this._answers[storageType].get( question );

  }

  static saveAge( age: string, type: 'parent' | 'adult' ) {

    const storageType = type === 'adult' ? StorageKeys.AdultAge : StorageKeys.ParentAge;

    this.clearAnswers( type );
    this._age[storageType] = age;
    localStorage.setItem( storageType, age );

  }

  static getAge( type: 'parent' | 'adult' ) {

    const storageType = type === 'adult' ? StorageKeys.AdultAge : StorageKeys.ParentAge;

    this.loadAnswers( type );

    return this._age[storageType];

  }

  static getAges( type: 'parent' | 'adult' ) {

    return ages[type];

  }

  static getNextQuestion( type: 'parent' | 'adult' ) {

    this.loadAnswers( type );

    const storageType = type === 'adult' ? StorageKeys.AdultAnswers : StorageKeys.ParentAnswers;

    return questions[type].find( ( question ) => !this._answers[storageType].has( question.id ) );

  }

  static getQuestions( type: 'parent' | 'adult' ) {

    return questions[type];

  }

  static getData( type: 'parent' | 'adult' ) {

    if ( type === 'parent' ) {

      this.loadAnswers( 'parent' );

      const ageData = ages.parent.find( ( item ) => item.id === this._age[StorageKeys.ParentAge] );

      if ( !ageData ) {

        return undefined;

      }

      return {
        level: levels[0],
        age: ageData,
      };

    }

    this.loadAnswers( 'adult' );

    const answeredAllQuestions = knowledgeQuestions.every(
      ( question ) => this._answers[StorageKeys.AdultAnswers].has( question.id ),
    );

    if ( !answeredAllQuestions || !this._age[StorageKeys.AdultAge] ) {

      return undefined;

    }

    const correctAnswers = knowledgeQuestions.filter( ( question ) => question.options.find(
      ( answer ) => answer.id === this._answers[StorageKeys.AdultAnswers].get( question.id ),
    )?.isCorrect ).length;

    const level = levels.find( ( item ) => correctAnswers >= item.minCorrectAnswers
      && correctAnswers <= item.maxCorrectAnswers );
    const ageData = ages.adult.find( ( item ) => item.id === this._age[StorageKeys.AdultAge] );

    if ( !level || !ageData ) {

      return undefined;

    }

    return {
      level,
      age: ageData,
    };

  }

}

export default Quiz;
